export const Services = {
  variable: ['$duration: Duration!', '$keyword: String!'],
  query: `
    services: searchServices(duration: $duration, keyword: $keyword) {
      key: id
      label: name
    }
  `,
};
export const ServicesForTeam = {
  variable: [
    '$duration: Duration!',
    '$serviceReq:ServiceReq!',
    '$permissions: [String]',
  ],
  query: `
    services: getServiceForTeam(duration: $duration, serviceReq:$serviceReq, permissions: $permissions) {
      key: id
      label: name
      permissions
    }
  `,
};

export const BrowserServices = {
  variable: ['$duration: Duration!'],
  query: `
    services: getAllBrowserServices(duration: $duration) {
      key: id
      label: name
    }
  `,
};

export const Database = {
  variable: '$duration: Duration!',
  query: `
    services: getAllDatabases(duration: $duration) {
      key: id
      label: name
    }
  `,
};

export const DatabaseService = {
  variable: '$serviceId: ID!, $duration: Duration!',
  query: `
    services: getDatabaseForService(duration: $duration, serviceId: $serviceId) {
      key: id
      label: name
    }
  `,
};

export const Endpoints = {
  variable: '$serviceId: ID!, $keyword: String!',
  query: `
    getEndpoints: searchEndpoint(serviceId: $serviceId, keyword: $keyword, limit: 100) {
      key: id
      label: name
    }
`,
};

export const RangeEndpoints = {
  variable: '$serviceId: ID!,$duration: Duration!',
  query: `
    getEndpoints: searchRangeEndpoint(serviceId: $serviceId, duration: $duration) {
      key: id
      label: name
    }
`,
};

export const EndpointSM = {
  variable: '$serviceId: ID!, $keyword: String!,  $pagination: Pagination',
  query: `
    getEndpoints: searchEndpointWithTotalCount(serviceId: $serviceId, keyword: $keyword, limit: 20, pagination: $pagination) {
    endpoints {
      key: id
      label: name
    }
    total
  }
`,
};

export const InstanceByMeta = {
  variable:
    '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair!]!',
  query: `
    instanceId: getServiceInstancesByMetaProperties(duration: $duration,serviceId: $serviceId, properties: $properties) {
      key: id
      label: name
      attributes {
        name
        value
      }
    }
`,
};

export const Instances = {
  variable: '$serviceId: ID!, $duration: Duration!',
  query: `
    getServiceInstances(duration: $duration, serviceId: $serviceId) {
      key: id
      label: name
      language
      attributes {
        name
        value
      }
    }
  `,
};
export const InstancesByServiceId = {
  variable: '$serviceId: ID!',
  query: `
    getServiceInstances(serviceId: $serviceId) {
      key: id
      label: name
    }
  `,
};

export const MobileInstances = {
  variable: '$serviceId: ID!, $duration: Duration!, $teamId: String',
  query: `
    getServiceInstances(duration: $duration, serviceId: $serviceId, teamId: $teamId) {
      key: id
      label: name
      attributes{
        name
        value
      }
    }
  `,
};

export const ServiceInstances = {
  variable: '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair]',
  query: `
  instanceId: getServiceInstances(duration: $duration, serviceId: $serviceId, properties: $properties) {     
    key: id
    label: name
    metaProperty1
    attributes {
      name
      value
    }
    isActive
}
  `,
};

export const OAPTimeInfo = {
  query: `
    getTimeInfo {
      timezone
      currentTimestamp
    }
  `,
};

export const ServiceLanguage = {
  variable: '$serviceId: ID!',
  query: `
    Language: getServiceLanguage(serviceId: $serviceId)
    `,
};

export const LabeledValues = {
  variable:
    '$condition: MetricsCondition!,  $labels: [String!]!,$duration: Duration!',
  query: `
  readLabeledMetricsLatestValue: readLabeledMetricsLatestValue(condition: $condition, labels: $labels, duration: $duration) {
    label
    value
  }`,
};

export const SessionDetails = {
  variable:
    '$condition: MetricsCondition!,  $labels: [String!]!,$duration: Duration!, $sortCriteria: [SortCriteria!]',
  query: `readLabeledMetricsLatestValue: readLabeledMetricsLatestValue(condition: $condition, labels: $labels,duration: $duration, sortCriteria: $sortCriteria) {
    label
    value
    timeStamp
  } `,
};

export const databaseQueryDetails = {
  variable:
    '$condition: AllCondition!,$duration: Duration!, $pagination: Pagination!, $sortCriteria: [SortCriteria!]',
  query: `readAllSampledRecords(condition:$condition, duration: $duration, pagination: $pagination, sortCriteria: $sortCriteria) {
    total,
    records {
      name,
      value,
      timestamp,
      count
    }}`,
};

export const eventQueryDetails = {
  variable:
    '$entityId: String!, $duration: Duration!,$pagination: Pagination!, $sortCriteria: [SortCriteria!]',
  query: `dbmEventTable(entityId: $entityId, duration: $duration, pagination: $pagination, sortCriteria: $sortCriteria) {
    total,
    tableValue{
        activity,
        source,
        sourceElapsed
    }
}`,
};

export const databaseAvgData = {
  variable: '$condition: MetricsCondition!, $duration: Duration!',
  query: `readMetricsValue:readMetricsValue(condition: $condition, duration: $duration)`,
};

export const bucketDetails = {
  variable:
    '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair!]!',
  query: `instanceId: getServiceInstancesByMetaProperties(duration: $duration, serviceId: $serviceId, properties: $properties) {     
    key: id
    label: metaProperty2
    attributes {
      name
      value
    }
  }`,
};

export const instanceByMetaProperty = {
  variable:
    '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair!]!',
  query: `instanceId: getServiceInstancesByMetaProperties(duration: $duration,serviceId: $serviceId, properties: $properties) {     
    key: id
    label: metaProperty1
    attributes {
      name
      value
    }
    isActive
}`,
};

export const QueryPerformanceInfo = {
  variable:
    '$condition: AllCondition!,$duration: Duration!, $pagination: Pagination!, $sortCriteria: [SortCriteria!]',
  query: `readAllSampledRecordsByTimeBucket(condition:$condition, duration: $duration, pagination: $pagination, sortCriteria: $sortCriteria) {
    total,
    records {
      name,
      value,
      timestamp,
      count
    }}`,
};

export const ServiceInstancesInfo = {
  variable: '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair]',
  query: `
  instanceId: getServiceInstances(duration: $duration, serviceId: $serviceId, properties: $properties) {     
    key: id
    label: name
    attributes {
      name
      value
    }
    isActive
}
  `,
};

export const getServiceForTeamWithTotalCount = {
  variable: [
    '$keyword: String',
    '$duration: Duration!',
    '$serviceReq: ServiceReq!',
    '$pagination: Pagination',
    '$permissions: [String]',
  ],
  query: `
    services: getServiceForTeamWithTotalCount(keyword: $keyword, duration: $duration, serviceReq: $serviceReq, pagination: $pagination, permissions: $permissions) {
      services {
        key: id
        label: name
        permissions
      }
      total
    }
  `,
};

export const serviceInstancesWithTotalCount = {
  variable:
    '$duration: Duration, $serviceId: ID!, $properties: [KeyValuePair], $pagination: Pagination, $keyword: String',
  query: `
  instanceId: getServiceInstancesWithTotalCount(duration: $duration, serviceId: $serviceId, properties: $properties, pagination: $pagination, keyword: $keyword) {     
    serviceInstances{
      key: id
      label: name
      attributes {
        name
        value
        }
        isActive
       }
    total
}
  `,
};

export const instancesWithTotal = {
  variable: [
    '$duration: Duration',
    '$serviceId: ID!',
    '$properties: [KeyValuePair!]!',
    '$pagination: Pagination',
    '$keyword: String',
  ],
  query: `instanceId: getServiceInstancesByMetaPropertiesWithTotal(duration: $duration,serviceId: $serviceId, properties: $properties, pagination: $pagination, keyword: $keyword) {
    serviceInstances {
      key: id
      label: name
      metaProperty1
      attributes {
        name
        value
      }
      isActive
    }
    total
}`,
};
